<template>
  <div v-if="currentCandidature && currentActivite">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-6 offset-lg-6">
          <table
            class="card table table-sm table-custom-primary table-bordered mb-0"
          >
            <tbody>
              <tr class="d-flex font-size-17 font-weight-bold">
                <td class="col-12">
                  <span class="text-custom-primary">
                    Appréciation de l'activité :</span
                  >

                  {{
                    currentActivite.appreciation
                      ? currentActivite.appreciation
                      : '###'
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 col-lg-6">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="$router.push({ name: listUrl }).catch(() => {})"
          >
            Liste des activités
          </button>
          <button
            v-if="
              currentOffre.statut === 0 && currentCandidature.embauche === false
            "
            type="button"
            class="btn btn-custom-primary mr-4"
            @click.prevent="
              $router
                .push({
                  name: listUrl + '-create',
                  params: {
                    id: currentCandidature.id,
                    offreId: offreId,
                    prov: prov,
                  },
                })
                .catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvelle activité
          </button>
          <button
            v-if="
              currentOffre.statut === 0 && currentCandidature.embauche === false
            "
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router
                .push({
                  name: listUrl + '-edit',
                  params: {
                    activiteId: currentActivite.id,
                    id: currentCandidature.id,
                    offreId: offreId,
                    prov: prov,
                  },
                })
                .catch(() => {})
            "
          >
            <i class="fa fa-edit font-size-17"></i> Modifier
          </button>
        </div>
        <div
          class="col-md-12 col-lg-6"
          v-if="
            currentOffre.statut === 0 && currentCandidature.embauche === false
          "
        >
          <button
            type="button"
            class="btn btn-custom-primary"
            @click="showModalAppreciation"
          >
            {{
              currentActivite.appreciation
                ? "Changer l'appréciation"
                : 'Donner une appréciation'
            }}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date début</span>
                  </td>
                  <td>
                    {{ currentActivite.date_debut }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Titre </span>
                  </td>
                  <td>
                    {{ currentActivite.titre }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentActivite.created_by.prenom
                        ? currentActivite.created_by.prenom +
                          ' ' +
                          currentActivite.created_by.nom
                        : currentActivite.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive bg-white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="far fa-calendar text-custom-primary"></i>
                    <span class="font-weight-bold"> Date fin</span>
                  </td>
                  <td>
                    {{ currentActivite.date_fin }}
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold">
                      Alerter envoyée par email ?
                    </span>
                  </td>
                  <td>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="currentActivite.notifier"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card
            class="text-black"
            header-class="bg-silver border-bottom-0"
            no-body
          >
            <template #header>
              <div>
                <h5 class="font-size-16 mb-0">
                  <i class="mdi mdi-comment-edit mr-0"></i> Description
                </h5>
              </div>
            </template>
            <div class="row editor">
              <div class="col-md-12">
                <vue-editor
                  id="description"
                  v-model="currentActivite.description"
                  :editorToolbar="VueEditorToolbar"
                  class="description"
                  :disabled="true"
                />
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <ModalAppreciation
      ref="modalAppreciation"
      :currentActivite="currentActivite"
      @onChangeAppreciation="onChangeAppreciation"
    />
  </div>
</template>

<script>
import URL from '@/http/rh/candidature/activite';
import { mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';
import VueEditorToolbar from '@/vue-editor-tool-bar';
import ModalAppreciation from './ModalAppreciation.vue';
export default {
  data() {
    return {
      VueEditorToolbar,
      currentActivite: null,
      prov: this.$route.params.prov,
      offreId: this.$route.params.offreId,
    };
  },
  components: {
    VueEditor,
    ModalAppreciation,
  },
  computed: {
    listUrl() {
      return this.$route.name.split('-')[0];
    },
    ...mapGetters('candidature', ['currentCandidature']),
    ...mapGetters('offreEmploi', ['currentOffre']),
  },
  methods: {
    showModalAppreciation() {
      this.$refs.modalAppreciation.showModal();
    },
    onChangeAppreciation(activite) {
      this.currentActivite = activite;
    },
    init() {
      window.axios
        .get(URL.ACTIVITE + '/' + this.$route.params.activiteId)
        .then((resp) => {
          this.currentActivite = resp.data.candidature_activite;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
